
    var riot = require('riot')
    //src: starling/src/tags/comments/comment-reaction-menu.html
riot.tag2('comment-reaction-menu',
  '<button class="Button Button--Plain Button--Icon" onclick="{voteCommentUp}" data-track="Comment-Action" data-track-action="Comment-Vote" data-track-label="Comment-Upvote"> <svg class="Button__Icon"> <use xlink:href="#thumbs-up-icon"></use> </svg> </button> <button class="Button Button--Plain Button--Icon" onclick="{voteCommentDown}" data-track="Comment-Action" data-track-action="Comment-Vote" data-track-label="Comment-Downvote"> <svg class="Button__Icon"> <use xlink:href="#thumbs-down-icon"></use> </svg> </button>',
  '',
  'show="{summoned}" class="comment-reaction-menu"', function(opts) {
'use strict';

var _this = this;

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

var _menuUi = require('lib/menu-ui');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _opts = opts,
    canvas = _opts.canvas;

canvas.commentReactionMenuTag = this;

this.positionSelf = _menuUi.mui.positionSelf.bind(this);

this.on('mount', function () {
  $(_this.root).on('mousedown touchstart pointerdown', function (event) {
    return event.stopImmediatePropagation();
  });
});

this.on('updated', _eventTracking2.default.listen(this.root));

this.toggle = function (_ref) {
  var comment = _ref.comment,
      referenceEl = _ref.referenceEl;

  if (_this.summoned && _this.comment === comment && _this.referenceEl === referenceEl) {
    _this.hide();
  } else {
    _this.summon({ comment: comment, referenceEl: referenceEl });
  }
};

this.summon = function (_ref2) {
  var comment = _ref2.comment,
      referenceEl = _ref2.referenceEl;

  Object.assign(_this, { comment: comment, referenceEl: referenceEl, summoned: true });

  _this.update();

  _this.positionSelf({
    referenceEl: referenceEl,
    selfEl: _this.root
  });
};

this.hide = function () {
  Object.assign(_this, { summoned: false, comment: null, referenceEl: null });
  _this.update();
};

this.voteCommentUp = function () {
  commentsUI.vote(_this.comment.id, 1);
  _this.hide();
};

this.voteCommentDown = function () {
  commentsUI.vote(_this.comment.id, -1);
  _this.hide();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('comment-reaction-menu')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/comments/comment-reaction-menu.html
// module id = 785
// module chunks = 0